<div class="flex flex-col" style="gap: 12px">
  <ng-container [ngSwitch]="entitlement.entitlement">
    <!-- Direct -->
    <ng-container *ngSwitchCase="entitlements.Direct">
      <li>
        Any direct booking sites, widgets, search bars, or redirects connected to our site will be deactivated and
        inaccessible.
      </li>

      <li>
        You will still be able to access your current direct bookings at active properties, communicate in the inbox,
        and will be paid out according to the normal schedule.
      </li>
    </ng-container>

    <!-- Smart devices -->
    <ng-container *ngSwitchCase="entitlements.SmartDevices">
      <li>
        Connected smart home device accounts will be removed, and any connected devices will no longer be managed.
      </li>

      <li>
        You may need to update messaging rules to no longer include the
        <code>%smartlock_code%</code>
        short code.
      </li>
    </ng-container>

    <!-- Parent child -->
    <ng-container *ngSwitchCase="entitlements.ParentChild">
      <li>
        Your configured parent-child relationships between properties will be dissolved. Any associated blocks in the
        parent or child properties will disappear.
      </li>
    </ng-container>
  </ng-container>
</div>
